import React, { useRef, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './ProfileDropdown.css';

interface ProfileDropdownProps {
  isOpen: boolean;
  onClose: () => void;
  onNavigate: (page: string) => void;
  darkMode?: boolean;
}

const ProfileDropdown: React.FC<ProfileDropdownProps> = ({
  isOpen,
  onClose,
  onNavigate,
  darkMode = false,
}) => {
  const { user, logout } = useAuth();
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        onClose();
      }
    };
    if (isOpen) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen, onClose]);

  if (!isOpen || !user) return null;

  const handleLogout = async () => {
    await logout();
    onClose();
  };

  const nav = (path: string) => {
    onNavigate(path);
    onClose();
  };

  return (
    <div className={`profile-dropdown-wrapper ${darkMode ? 'dark' : 'light'}`} ref={dropdownRef}>
      <div className="profile-dropdown">
        <div className="profile-header">
          <div className="profile-info">
            <p className="profile-name">{user.name}</p>
            <p className="profile-email">{user.email}</p>
          </div>
        </div>
        <div className="profile-menu">
          <button className="profile-menu-item" onClick={() => nav('/my-referrals')}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M10 8h6M13 5v6M6 14a6 6 0 100-12 6 6 0 000 12z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            My Referrals
          </button>
          <button className="profile-menu-item" onClick={() => nav('/post-vacancy')}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M8 1v14M1 8h14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Post Vacancy
          </button>
          <button className="profile-menu-item" onClick={() => nav('/profile')}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M8 8a3 3 0 100-6 3 3 0 000 6zM14 14v-1a3 3 0 00-3-3H5a3 3 0 00-3 3v1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Profile
          </button>
          <div className="profile-menu-divider"></div>
          <button className="profile-menu-item" onClick={handleLogout}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M6 14H3.333A1.333 1.333 0 012 12.667V3.333A1.333 1.333 0 013.333 2H6M10.667 11.333L14 8m0 0l-3.333-3.333M14 8H6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileDropdown;
